import { isNil } from "./ramdaEquivalents.utils";
export var copyElementContents = function (el) {
    if (!el)
        return null;
    var body = document.body;
    var range;
    var sel;
    if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        if (!sel)
            return null;
        sel.removeAllRanges();
        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        }
        catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
        document.execCommand("copy");
    }
    else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
        range.execCommand("Copy");
    }
};
export var copyString = function (string) {
    if (isNil(string))
        return;
    var textarea = document.createElement('textarea');
    textarea.setAttribute('value', string);
    textarea.innerHTML = string;
    textarea.setAttribute('style', "\n\t\topacity: 0;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\ttransform: translate(-100%, -100%);\n\t");
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};
